<template>
  <b-container class="registration-process">
    <div class="d-inline-block">
      <p :key="index" v-for="(item, index) in items">
        <b-btn
          v-b-toggle="item.title[0].text"
          variant="link"
          class="title font-weight-bold"
        >
          <span v-if="item.marker">{{ item.marker }}</span>
          <span v-else>{{ index + 1 }}.</span>
          <span
            :key="index"
            :lang="title.lang"
            v-for="(title, index) in item.title"
          >
            {{ title.text }}
            <span v-if="index < item.title.length - 1">/</span>
          </span>
        </b-btn>

        <b-collapse :id="item.title[0].text">
          <router-link :to="item.link" v-if="item.link">
            <b-btn variant="red" class="float-right" v-if="item.action">
              {{ item.action }}
            </b-btn>
          </router-link>
          <a :href="item.externalLink" target="_blank" v-else>
            <b-btn variant="red" class="float-right" v-if="item.action">
              {{ item.action }}
            </b-btn>
          </a>
          <span>
            <span :key="index" v-for="(description, index) in item.description">
              <span v-html="description" />
              <br v-if="index < item.description.length - 1" />
            </span>
          </span>
        </b-collapse>
      </p>
    </div>
  </b-container>
</template>

<script>
import Vue from "vue";

export default Vue.component("RegistrationProcess", {
  data() {
    return {
      items: [
        {
          title: [
            {
              lang: "ko",
              text: "등록"
            },
            {
              lang: "en",
              text: "Registration"
            }
          ],
          description: [
            "pixpills의 멤버가 되기 위해서는 간단한 등록절차가 필요합니다.",
            "신청서 작성 링크에서 확인하세요."
          ],
          action: "신청서 작성",
          externalLink: "https://goo.gl/forms/A6Q1mYe5Pl25LHAW2"
        },
        {
          title: [
            {
              lang: "ko",
              text: "심사"
            },
            {
              lang: "en",
              text: "Judgement"
            }
          ],
          description: [
            "보내주신 신청서와 포트폴리오를 통해 승인 여부를 심사합니다. (심사 기간 약 5~7일)",
            "&emsp;- 본 심사는 작가님들의 실력을 판단하기 위함이 아닙니다.",
            "아티스트와 pixpills가 함께하여 시너지를 발생시킬 수 있는지에 대한 주관적인 심사이며,",
            "이는 pixpills의 운영진이 책임감을 가지고 운영하기 위함입니다."
          ]
        },
        {
          title: [
            {
              lang: "ko",
              text: "승인"
            },
            {
              lang: "en",
              text: "Approval"
            }
          ],
          description: [
            "1. 승인이 완료된 크리에이터에게는 개별 도메인과 온라인 갤러리를 제공합니다.",
            "2. 갤러리를 효과적으로 관리하기 위한 매뉴얼을 전달 드립니다."
          ]
        },
        {
          marker: "*",
          title: [
            {
              lang: "ko",
              text: "멤버쉽"
            },
            {
              lang: "en",
              text: "Membership"
            }
          ],
          description: [],
          action: "혜택 확인",
          link: "/about/artists/benefits/"
        }
      ]
    };
  }
});
</script>

<style lang="scss" scoped>
$grid-gutter-width: 10px;
@import "~bootstrap/scss/bootstrap-grid.scss";

* {
  font-size: 13px;
  color: black;
}

.registration-process {
  margin-top: 32px;

  @include media-breakpoint-up(lg) {
    min-height: calc(100vh - 120px);
  }
}

.title {
  padding: 0;
  text-decoration: none;

  &:hover {
    color: black;
    text-decoration: underline;
  }

  span {
    font-size: 45px;

    &[lang="en"] {
      font-size: 49px;
    }
  }
}
</style>
